module.exports = __webpack_public_path__ + "8057914872dd504b119a453e8c81e239.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/official-icons/coin-s.png
// module id = 1698
// module chunks = 0